module.exports = __webpack_public_path__ + "static/media/image_28.b808f560.png";